import { ConfigType } from '@stitches/react/types/config';

const hue = 39;
const saturation = '95%';
const lightness = '54%';

const theme: ConfigType.Theme = {
  fonts: {
    poppins: "'poppins', sans-serif",
  },
  colors: {
    'blue-100': '#b4d7e9',
    'gray-50': '#F6F6F6',
    'gray-100': '#EEEEEE',
    'gray-200': '#E2E2E2',
    //preview
    'brand-hue': hue,
    'brand-saturation': saturation,
    'brand-lightness': lightness,
    brand: 'hsl($brand-hue $brand-saturation $brand-lightness)',
    // background: 'hsl($brand-hue $brand-saturation $brand-lightness / 10%)',
    // text1: 'hsl($brand-hue $brand-saturation 10%)',
    background: 'rgb(247, 248, 249)',
    background2: '#F7F8F9',
    text1: '#021337',
    text2: '#4E5A73',
    text3: '#677187',
    contentTertiary: '#677187',
    surface1: 'rgb(255, 255, 255)',
    surface2: 'hsl($brand-hue 20% 92%)',
    surface3: 'hsl($brand-hue 25% 90%)',
    surface4: 'hsl($brand-hue 20% 85%)',
    mask: '#000000',

    // foundation
    positive: '#17AFA7',
    negative: '#D33C0C',
    accent: '#2844CE',
    active: '#0D9A62',
    // app
    border: '#D9DCE1',
    dark: '#6e6e6e',
    danger: '#CF4C22',
    warning: '#F58021',
    error: '#FF2625',
    link: '#0479B7',

    'bg-light-accent': '#F5F7FF',
    'bg-light-blue-grey': '#EBEDF4',
    'bg-tertiary': '#E8EAED',
    'bg-teriary': '#D9DCE1',
    'bg-secondary': '#F7F8F9',
    'bg-positive': '#0EAB6D',
    'bg-active': '#B7E6D3',

    'content-primary': '#021337',
    'content-secondary': '#4E5A73',
    'content-tertiary': '#677187',
    'content-disabled': '#7D8493',

    // preview util
    woSurface1: '$brand-hue 20% 99%',

    selected: '#000',
    hover: 'hsl( calc($brand-hue - 10) $brand-saturation $brand-lightness)',
    click: '#000',

    // with utility
    primary: '0,0,0',
    text: '0,0,0',
    // background: '255, 255, 255',
    // hover: '50,50,50',

    // nomal
    divide: 'rgb(0,0,0, 10%)',
    // danger: '#ff4d4f',
  },
  fontSizes: {
    base: '0.875rem',
    title: '1rem',
    iconSmall: '13px',
    iconMiddle: '36px',
    4: '1.25rem',
  },
  sizes: {
    header: '80px',
    hug: '550px',
    xs: '480px',
    se: '375px',
  },
  space: {},
  shadows: {
    // preview
    surface: '$colors$brand-hue 10% 20%',
    strength: 0.2,
    rad: `0 2.8px 2.2px hsl($surface / calc($strength + .03)),
            0 6.7px 5.3px hsl($surface / calc($strength + .01)),
            0 12.5px 10px hsl($surface / calc($strength + .02)),
            0 22.3px 17.9px hsl($surface / calc($strength + .02)),
            0 41.8px 33.4px hsl($surface / calc($strength + .03)),
            0 100px 80px hsl($surface / $strength)`,

    light: '0px 12px 25px 0px rgb(0 0 0 / 4%)',
  },
  radii: {
    radius: '28px',
    base: '5px',
    sm: '8px',
  },
};

export default theme;
